import React from 'react';
import Utils from '../modules/Utils';

export default class DisplayTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if(!window.displayTables) {
            window.displayTables = {};
        }
        this.initDataTable();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const cssId = "display-table-"+this.props.tableId;
        const filters = Utils.get(nextProps, "filters");
        console.log("filters", filters, nextProps);
        if(!Utils.empty(filters)) {
            const tableRef = window.displayTables[cssId];
            const tableObj = tableRef['obj'];
            const tableFilters = tableRef['filters'];
            if(filters != tableFilters) {
                //alert("Filter change");
                const filterList = filters.split(",");
                let filter = filterList[0];
                console.log("FILTER", filter);
                if(filter == "none:none") {
                    tableObj.search('').columns().search('').draw();
                } else {
                    tableObj.search('').columns().search('').draw();
                    let parts = filter.split(":");
                    const field = parts[0];
                    if(this.props.colList) {
                        let colIndex = this.props.colList.indexOf(field);
                        if(parts.length == 2 && colIndex != -1) {
                            const val = parts[1];
                            tableObj.column(colIndex).search(val, true, false).draw();
                        }
                    }
                }
                tableRef['filters'] = filters;
            }
        }
    }

    initDataTable = () => {
        const cssId = "display-table-"+this.props.tableId;
        console.log("Init DisplayTable", cssId);
        if(!window.displayTables[cssId]) {
            //window.table = $(cssId).DataTable({order: [[0, 'asc']]});
            const tableObj = $("#"+cssId).DataTable({order: [[0, 'asc']]});
            const tableRef = {obj:tableObj, filters:"none:none"};
            window.displayTables[cssId] = tableRef;
        }
    };

    render() {
        const pr = this.props;
        const colList = pr.colList;
        const colTitleList = !pr.colTitleList ? pr.colList : pr.colTitleList;
        const maxHeight = pr.maxHeight ? pr.maxHeight : 75;
        const rows = pr.rows;
        const cssId = "display-table-"+this.props.tableId;
        console.log("DISPLAY TABLE ROWS", pr, cssId);
        //return null;

        return (
            <table id={cssId} className="display" style={{fontSize:12}}>
                <thead>
                    <tr>
                        {colTitleList.map((colHead, idxHead) => {
                            return <th key={`idx-dt-colhead-${this.props.tableId}-${idxHead}`}>{colHead}</th>
                        })}

                    </tr>
                </thead>
                { rows ?
                    <tbody>
                        {pr.rows.map((curRow, idxRow) => {
                            return (
                                <tr key={`idx-dt-colrow-${this.props.tableId}-${idxRow}`}>
                                    {colList.map((colName, idxCol) => {
                                        let data = Utils.get(curRow, colName, "");
                                        if(typeof data != "number" && Utils.empty(data)) {
                                            data = "";
                                        }
                                        if(typeof data == "string") {
                                            if(data.substr(0,12) == "walmart.com/") {
                                                data = "https://" + data;
                                            }
                                            if(data.substr(0,4) == "http") {
                                                data = <a target="_blank" href={data}><i className="fa fa-external-link"></i></a>
                                            } else {
                                                data = <div  style={{maxHeight:maxHeight,overflowY:"scroll"}}>{data}</div>
                                            }
                                        }
                                        return <td key={`idx-dt-colrow-${this.props.tableId}-${idxRow}-${idxCol}`}>{data}</td>
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                    :
                    <tbody>
                    No Rows
                    </tbody>
                }

            </table>
        );
    }

    styles = {
        label: {
            width: '100%',
            padding: '12px',
        },
        error: {
            textAlign: 'left',
            fontSize: 12,
            color: 'red',
            paddingTop: 6,
        },
        valid: {
            textAlign: 'left',
            fontSize: 12,
            color: 'green',
            paddingTop: 6,
        }
    };
}
